import React, { useEffect, useState } from "react";
import { getFilteredIncompleteFeesDetails } from "../services/api"; 
import { motion } from "framer-motion"; 
const classOrder = ["الأول", "الثاني", "الثالث", "الرابع", "الخامس","السادس", "السابع", "الثامن", "التاسع", "العاشر", "الحادي عشر"];

const SkeletonCard = () => (
  <div className="bg-white rounded-xl shadow-md p-6 animate-pulse">
    <div className="h-7 bg-slate-200 rounded w-1/4 mb-5"></div>
    <div className="space-y-3">
      <div className="h-8 bg-slate-200 rounded"></div>
      <div className="h-8 bg-slate-200 rounded"></div>
      <div className="h-8 bg-slate-200 rounded"></div>
    </div>
  </div>
);

const EmptyState = () => ( 
  <div className="text-center py-16 px-6 bg-white rounded-xl shadow-md">
    <svg className="mx-auto h-12 w-12 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
    <h3 className="mt-4 text-lg font-medium text-slate-900">هناك ثلاث حالات لظهور هذه الصفحة خالية</h3>
    <p className="mt-2 text-lg text-slate-700">1- لم يتم تعيين الرسوم الدراسية بعد</p>
    <p className="mt-2 text-lg text-slate-700">2- لم تتم عملية افراز الطلاب على الشعب بعد</p>
   <p className="mt-2 text-lg text-slate-700">3- بخلاف الحالتين الأولى والثانية فيبدوا أن جميع الطلاب قد سددوا كامل القسط بالفعل</p> 
  </div>
);

const generateAcademicYears = (start = 2025, count = 11) => { 
  return Array.from({ length: count }).map((_, i) => {
    const s = start + i;
    const e = s + 1;
    return `${s}-${e}`;
  });
};

const getCurrentAcademicYear = () => {
  const now = new Date();
  const month = now.getMonth() + 1;
  const year = now.getFullYear();
  const start = month >= 9 ? year : year - 1;
  return `${start}-${start + 1}`;
};

const IncompleteFeesPage = () => {
  const [originalData, setOriginalData] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedClass, setSelectedClass] = useState("ALL");
  const [selectedRoom, setSelectedRoom] = useState("ALL");
  const [selectedAcademicYear, setSelectedAcademicYear] = useState(getCurrentAcademicYear());
  const [classOptions, setClassOptions] = useState([]); 
  const [roomOptions, setRoomOptions] = useState([]);
  const [page, setPage] = useState(1); 
  const [limit] = useState(1000);

  const academicYears = generateAcademicYears(2025, 11);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const params = {
          page,
          limit
        }; 
        if (selectedAcademicYear && selectedAcademicYear !== "") { 
          params.academicYear = selectedAcademicYear;
        }
        if (selectedClass && selectedClass !== "ALL") {
          params.className = selectedClass;
        }
        if (selectedRoom && selectedRoom !== "ALL") {
          params.roomNumber = selectedRoom;
        }

        const res = await getFilteredIncompleteFeesDetails(params); 
        const arr = Array.isArray(res?.data) ? res.data : (Array.isArray(res) ? res : []);
        setOriginalData(arr);
        const classesSet = new Set();
        arr.forEach(g => classesSet.add(g.className)); 
        const orderedClasses = Array.from(classesSet).sort((a, b) => {
          const ia = classOrder.indexOf(a);
          const ib = classOrder.indexOf(b);
          if (ia !== -1 || ib !== -1) return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib);
          return a.localeCompare(b);
        });
        setClassOptions(orderedClasses);

        const allRooms = Array.from(new Set(arr.map(g => g.roomNumber))).sort((a, b) => a.localeCompare(b));
        setRoomOptions(allRooms);

        setData(sortResult(arr));
      } catch (err) { 
        console.error("Error fetching incomplete fees:", err);
        setOriginalData([]);
        setData([]);
      } finally { 
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedClass, selectedRoom, selectedAcademicYear, page]); 

  const sortResult = (list) => {
    return list.slice().sort((a, b) => {
      if (a.className !== b.className) {
        const ia = classOrder.indexOf(a.className);
        const ib = classOrder.indexOf(b.className);
        if (ia !== -1 || ib !== -1) return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib); 
        return a.className.localeCompare(b.className);
      }
      return a.roomNumber.localeCompare(b.roomNumber); 
    });
  }; 

  useEffect(() => {
    if (selectedClass === "ALL") {
      const globalRooms = Array.from(new Set(originalData.map(g => g.roomNumber))).sort((a, b) => a.localeCompare(b));
      setRoomOptions(globalRooms);
    } else {
      const roomsForClass = Array.from(new Set(
        originalData.filter(g => g.className === selectedClass).map(g => g.roomNumber)
      )).sort((a, b) => a.localeCompare(b));
      setRoomOptions(roomsForClass);
      if (selectedRoom !== "ALL" && !roomsForClass.includes(selectedRoom)) {
       setSelectedRoom("ALL"); 
      }
    }

    let filtered = originalData;
    if (selectedClass !== "ALL") filtered = filtered.filter(g => g.className === selectedClass);
    if (selectedRoom !== "ALL") filtered = filtered.filter(g => g.roomNumber === selectedRoom);
    setData(sortResult(filtered));
  }, [selectedClass, selectedRoom, originalData]);
 const resetFilters = () => {
    setSelectedClass("ALL");
    setSelectedRoom("ALL");
    setSelectedAcademicYear("");
  };
  const hasData = data.length > 0; 

  const totalRemainingFees = data.reduce((sum, group) => {
    return sum + group.students.reduce((inner, s) => inner + Number(s.remainder || 0), 0);
  }, 0);
 const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.1 } },
  };
 const itemVariants = { 
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { type: "spring", stiffness: 100 } },
  };
 return (
    <div className="bg-slate-50 min-h-screen font-sans" dir="rtl">
      <div className="container mx-auto p-4 sm:p-6 lg:p-8">
        <header className="mb-6 text-center sm:text-right">
          <h1 className="text-4xl font-extrabold text-slate-800 tracking-tight">الرسوم الدراسية غير المكتملة</h1>
          <p className="mt-2 text-xl text-slate-700">هذه القيم لا تتضمن رسوم النقل وإنما الرسوم الدراسية مخصوم منها الحسومات بحال وجدت .</p>

        </header>

        <div className="mb-6 
         grid grid-cols-1 sm:grid-cols-4 gap-4 items-end"> 
          <div>
            <label className="block text-lg font-medium text-slate-700 mb-1">السنة الدراسية</label>
            <select
              value={selectedAcademicYear}
              onChange={(e) => setSelectedAcademicYear(e.target.value)}
              className="w-full rounded-md border-slate-200 shadow-sm py-2 px-3 bg-white">
             {academicYears.map((y) => ( 
                <option key={y} value={y}>{y}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block 
             text-lg font-medium text-slate-700 mb-1">الصف</label>
            <select
              value={selectedClass}
              onChange={(e) => setSelectedClass(e.target.value)}
              className="w-full rounded-md border-slate-200 shadow-sm py-2 px-3 bg-white"
            >
              <option value="ALL">كل الصفوف</option>
              {classOptions.map((c) => <option key={c} value={c}>{c}</option>)} 
            </select>
          </div>

          <div>
            <label className="block text-lg font-medium text-slate-700 mb-1">الشعبة</label>
            <select
              value={selectedRoom}
              
             onChange={(e) => setSelectedRoom(e.target.value)}
              className="w-full rounded-md border-slate-200 shadow-sm py-2 px-3 bg-white"
            >
              <option value="ALL">كل الشعب</option>
              {roomOptions.map((r) => <option key={r} value={r}>{r}</option>)}
            </select>
          </div>

          
         <div className="flex gap-3"> 
            <button onClick={resetFilters} className="px-4 py-2 rounded-md bg-slate-100 text-slate-800 border border-slate-200 hover:bg-slate-200">
              إعادة تعيين
            </button>

            <div className="px-4 py-2 rounded-md bg-white text-slate-900 border border-slate-200 flex items-center">
              <span className="text-lg font-medium ml-2">مجموع المبالغ المتبقية</span>
             <span className="text-lg font-bold text-red-600">{totalRemainingFees.toLocaleString()} <span className="text-md font-normal text-slate-900">ل.س</span></span> 
            </div>
          </div>
        </div>

        {loading ?
         (
          <div className="space-y-8">
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
          </div>
        ) : !hasData ?
         ( 
          <EmptyState />
        ) : (
          <motion.div className="space-y-8" variants={containerVariants} initial="hidden" animate="visible">
            {data.map((group) => (
              <motion.div key={`${group.className}-${group.roomNumber}`} variants={itemVariants} className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden">
                <div className="p-5 border-b border-slate-200 bg-slate-50 flex justify-between items-center">
     
                 <h2 className="text-2xl font-bold text-indigo-600">الصف: {group.className} (شعبة {group.roomNumber})</h2> 
                  <span className="text-sm font-medium bg-indigo-100 text-indigo-600 py-1 px-3 rounded-full">{group.students.length} طلاب</span>
                </div>
                <div className="overflow-x-auto">
                  <table className="min-w-full text-right">
  
                   <thead className="border-b border-slate-200"> 
                      <tr>
                        <th className="px-6 py-3 text-lg font-semibold text-slate-900">الاسم الكامل</th>
                        <th className="px-6 py-3 text-lg font-semibold text-slate-900">الرقم التسلسلي</th> 
                        <th className="px-6 py-3 text-lg font-semibold text-slate-900">المبلغ المتبقي</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
    
                     {group.students.map((student) => ( 
                        <tr key={student.serialNumber} className="hover:bg-slate-50 transition-colors">
                          <td className="px-6 py-4 whitespace-nowrap text-lg font-medium text-slate-900">{student.fullName ||
                           student.serialNumber}</td> 
                          <td className="px-6 py-4 whitespace-nowrap text-lg  text-slate-900">{student.serialNumber}</td>
                          <td className="px-6 py-4 whitespace-nowrap text-lg font-bold text-red-600">{Number(student.remainder).toLocaleString()} <span className="text-md font-normal text-slate-900">ل.س</span></td>
                        </tr>
         
                     ))} 
                    </tbody>
                  </table>
                </div>
              </motion.div>
            ))}
       
          </motion.div> 
        )}
      </div>
    </div>
  );
};
export default IncompleteFeesPage;